import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import PlatformList from './components/PlatformList';
import UIFooter from './components/UIFooter';
import UILayout from './components/UILayout';
import ProcessGuide from './components/ProcessGuide';
import "./mainPage.css"

const MainPage = () => (
    <div className='main-container mb-4'>
        {/* Main layout section */}
        <UILayout />

        {/* Main content */}
        <Container className="mt-5 ">
            <Row className="align-items-start">
                {/* Welcome Text */}
                <Col md={8} className='content-mainpage'>
                    <h1>Welcome to Technical Paper Submission</h1>
                    <p> This system is designed to streamline the submission, review, and management of technical papers.
                        Whether you're a host, reviewer, or author, our platform provides the tools you need to succeed.</p>
                </Col>
            </Row>

            {/* Platform List */}
            <Row className="mt-4 align-items-start p-5"> {/* Or use align-items-center to center */}
                <Col md={8}>
                    <PlatformList />
                </Col>
                <Col md={4} className="container d-flex justify-content-end align-self-start mt-5 mb-5 pdf-card"> {/* adjust alignment as needed */}
                        <ProcessGuide />
                </Col>
            </Row>

        </Container>

        {/* Footer */}
        <UIFooter />
    </div>
);

export default MainPage;
